import React from 'react';
import { useLearningData } from '../context/LearningDataContext';
export function useLearningProgress() {
  const {
    learningData,
    updateLessonStatus
  } = useLearningData();
  const checkLessonAvailability = (courseId: number, unitId: number, lessonId: number): boolean => {
    // Find the course
    const course = learningData.find(course => course.id === courseId);
    if (!course) return false;
    // Find the unit
    const unit = course.units.find((unit: any) => unit.id === unitId);
    if (!unit) return false;
    // Find the lesson
    const lesson = unit.lessons.find((lesson: any) => lesson.id === lessonId);
    if (!lesson) return false;
    // If lesson has no unlock condition, it's available
    if (!lesson.unlockCondition) return true;
    // Check if previous lesson is completed
    if (lesson.unlockCondition.lessonId) {
      const prevLesson = unit.lessons.find((l: any) => l.id === lesson.unlockCondition.lessonId);
      return prevLesson?.isCompleted ?? false;
    }
    // Check unit progress condition
    if (lesson.unlockCondition.unitProgress) {
      return unit.progress >= lesson.unlockCondition.unitProgress;
    }
    return true;
  };
  const completeLesson = (courseId: number, unitId: number, lessonId: number) => {
    updateLessonStatus(courseId, unitId, lessonId, true);
  };
  const resetLesson = (courseId: number, unitId: number, lessonId: number) => {
    updateLessonStatus(courseId, unitId, lessonId, false);
  };
  return {
    checkLessonAvailability,
    completeLesson,
    resetLesson
  };
}